module.exports = __webpack_public_path__ + "static/img/defaulthead_bg.150754d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userCenter/defaulthead_bg.png
// module id = 7i5D
// module chunks = 16